module.exports = __webpack_public_path__ + "img/video-lesson-main-min.114f0c66.jpg";